module.exports = __webpack_public_path__ + "dc07d1b138419fcf85cad0f2f5d8faca.png";